import { render, staticRenderFns } from "./EditLevelPage.vue?vue&type=template&id=2b80797a&scoped=true&"
import script from "./EditLevelPage.vue?vue&type=script&lang=js&"
export * from "./EditLevelPage.vue?vue&type=script&lang=js&"
import style0 from "./EditLevelPage.vue?vue&type=style&index=0&id=2b80797a&prod&lang=scss&scoped=true&"
import style1 from "./EditLevelPage.vue?vue&type=style&index=1&id=2b80797a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b80797a",
  null
  
)

export default component.exports